/* istanbul ignore file */
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import type { EventsMap } from '@noths/polaris-client-next-redux';

import { productListClick } from 'src/components/organisms/ProductList/modules/actions';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { getPartnerShortcodeFromCanonicalFilters } from 'src/redux/productsQuery/utils/getPartnerShortcodeFromCanonicalFilters';
import { getProductClickTrackingEvent } from 'src/tracking/events/productClick';
import { getPageTrackingContext } from 'src/tracking/utils/getPageTrackingContext';
import { getFieldObjectList, getProductFieldObject } from 'src/utils/googleAnalytics';

/* The shopper's navigation to the product page waits on this callback, so cap it well
   below the 500ms GTM is otherwise given. */
export const PRODUCT_CLICK_TRACKING_TIMEOUT_MS = 150;

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [productListClick.type]: (state, _nextState, action) => {
    const {
      payload: { destinationUrl, linkOpensInSameWindow, productCode, productUrl },
    } = action as ReturnType<typeof productListClick>;
    const { products, productsQuery } = state;
    const { pages, productsReturnedCount } = products;

    const context = getPageTrackingContext(state);
    const partnerShortcode = getPartnerShortcodeFromCanonicalFilters(
      productsQuery.canonicalFilters,
    );

    const clickedProduct = Object.values(pages)
      .flat()
      .find((prod) => prod.code === productCode)!;

    const event = getProductClickTrackingEvent({
      eventCategory: 'Product listings',
      destinationUrl,
      eventLabel: 'null',
      actionFieldList: getFieldObjectList(
        context.pageType,
        partnerShortcode || context.entityName,
        clickedProduct.isExpandedSearch ? ' - expanded' : undefined,
      ),
      products: [getProductFieldObject(clickedProduct, pages, productsReturnedCount, context)],
    });

    sendGAEvent({ ...event, eventTimeout: PRODUCT_CLICK_TRACKING_TIMEOUT_MS }).then(() => {
      if (linkOpensInSameWindow) {
        window.location.assign(productUrl);
      }
    });
  },
};
